// extracted by mini-css-extract-plugin
export default {"cardstyle":"productHelp_cardstyle__2Minh"};